export function getToday () {
  const today = new Date()
  const year = today.getFullYear()
  let month = today.getMonth() + 1 // 月份从0开始，需要加1
  if (month < 10) {
    month = '0' + month
  }
  const day = today.getDate()

  return year + '-' + month + '-' + day
}

export function parseStockStr (changeStock) {
  // 使用正则表达式提取数值部分
  const match = changeStock.match(/-?\d+/)
  if (match) {
    return parseInt(match[0], 10) // 转换为数字
  }
  return 0 // 如果无法解析，默认返回 0
}
